import { JSONSchemaType } from "ajv";

export type AryRiscsAvailable = {
  risk_qualification_id: string,
  risk_qualification_nom: string
}[];
export const schemaAryRiscsAvailable: JSONSchemaType<AryRiscsAvailable> = {
  "type":"array",
  "items": {
    "type": "object",
    "properties": {
      "risk_qualification_id": { "type": "string" },
      "risk_qualification_nom": { "type": "string" }
    },
    "required":[ "risk_qualification_id", "risk_qualification_nom" ]
  }
}

export type AryRiscSources = {
  risk_source_type_id: number,
  risk_source_name: string
}[];
export const schemaAryRiscSources: JSONSchemaType<AryRiscSources> = {
  "type":"array",
  "items": {
    "type": "object",
    "properties": {
      "risk_source_type_id": { "type": "number" },
      "risk_source_name": { "type": "string" }
    },
    "required":[ "risk_source_type_id", "risk_source_name" ]
  }
}

export type AryMesuresTypes = {
  measure_type_id: string,
  measure_type_name: string
}[];
export const schemaAryMesuresTypes: JSONSchemaType<AryMesuresTypes> = {
  "type":"array",
  "items": {
    "type": "object",
    "properties": {
      "measure_type_id": { "type": "string" },
      "measure_type_name": { "type": "string" }
    },
    "required":[ "measure_type_id", "measure_type_name" ]
  }
}

export type AryEstatsMesures = {
  status_id: number,
  status_name: string
}[];
export const schemaAryEstatsMesures : JSONSchemaType<AryEstatsMesures> = {
  "type":"array",
  "items": {
    "type": "object",
    "properties": {
      "status_id": { "type": "number" },
      "status_name": { "type": "string" }
    },
    "required":[ "status_id", "status_name" ]
  }
}

export type AryContacteTecnics = Array<{
    name: string, surname: string, second_surname: string,
    contact_methods: Array<{ contact_method_type: "M" | "E", contact_method_data: string }>
}>;
export const schemaContacteTecnics: JSONSchemaType<AryContacteTecnics> = {
    "type": "array",
    "items": {
      "type": "object",
      "properties": {
        "name": { "type": "string" },
        "surname": { "type": "string" },
        "second_surname": { "type": "string" },
        "contact_methods": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "contact_method_type": {
                "type": "string",
                "enum": ["M", "E"]
              },
              "contact_method_data": { "type": "string" }
            },
            "required": ["contact_method_type", "contact_method_data"]
          }
        }
      },
      "required": ["name", "surname", "second_surname", "contact_methods"]
    }
  }

export type AryUserInfo = {
  contact_id:string,
  name: string,
  surname: string,
  second_surname: string,
  birth_date: string,
  age: number,
  sex_id: string,
  contact_methods: {
    contact_method_type:'T'|'E'|'C'|'M',
    contact_method_name: string,
    contact_method_data: string | {
      address: string,
      autonomous_community_id: number,
      autonomous_community_name: string,
      country_id: number,
      country_name: string,
      province_id: number,
      province_name: string,
      region_id: number,
      region_name: string,
      town_id: number,
      town_name: string,
      zip_code: string,
      zip_code_id: number,
    },
    personal: 0 | 1
  }[]
}[];
export const schemaAryUserInfo: JSONSchemaType<AryUserInfo> = {
  "type": "array",
  "items": {
    "type": "object",
    "properties": {
      "contact_id": { "type": "string" },
      "name": { "type": "string" },
      "surname": { "type": "string" },
      "second_surname": { "type": "string" },
      "birth_date": { "type": "string", "format": "date" },
      "age": { "type": "number" },
      "sex_id": { "type": "string" },
      "contact_methods": {
        "type": "array",
        "items": {
          "type": "object",
          "properties": {
            "contact_method_type": { "type":"string", "enum": ["T", "E", "C", "M"] },
            "contact_method_name": { "type": "string" },
            "contact_method_data": {
              "oneOf": [
                { "type": "string" },
                {
                  "type": "object",
                  "properties": {
                    "address": { "type": "string" },
                    "autonomous_community_id": { "type": "number" },
                    "autonomous_community_name": { "type": "string" },
                    "country_id": { "type": "number" },
                    "country_name": { "type": "string" },
                    "province_id": { "type": "number" },
                    "province_name": { "type": "string" },
                    "region_id": { "type": "number" },
                    "region_name": { "type": "string" },
                    "town_id": { "type": "number" },
                    "town_name": { "type": "string" },
                    "zip_code": { "type": "string" },
                    "zip_code_id": { "type": "number" }
                  },
                  "required": [
                    "address",
                    "autonomous_community_id",
                    "autonomous_community_name",
                    "country_id",
                    "country_name",
                    "province_id",
                    "province_name",
                    "region_id",
                    "region_name",
                    "town_id",
                    "town_name",
                    "zip_code",
                    "zip_code_id"
                  ]
                }
              ]
            },
            "personal": { "type":"number", "enum": [0, 1] }
          },
          "required": ["contact_method_type", "contact_method_name", "contact_method_data", "personal"]
        }
      }
    },
    "required": ["contact_id", "name", "surname", "birth_date", "age", "sex_id", "contact_methods"]
  }
}


export type AryUserCompanies = {
    company_id: string,
    company_name: string
}[];
export const schemaAryUserCompanies: JSONSchemaType<AryUserCompanies> = {
  "type": "array",
  "items": {
    "type": "object",
    "properties": {
      "company_id": { "type": "string" },
      "company_name": { "type": "string" }
    },
    "required": ["company_id", "company_name"]
  }
}

export type AryWorkPlaces = Array<{
      workplace_id: number,
      workplace_name: string,
      sections?: Array<{ section_id: number, section_name: string }>
}>;
export const schemaAryWorkPlaces: JSONSchemaType<AryWorkPlaces> = {
  "type": "array",
  "items": {
    "type": "object",
    "properties": {
      "workplace_id": { "type": "number" },
      "workplace_name": { "type": "string" },
      "sections": {
        "type": "array",
        "nullable": true,
        "items": {
          "type": "object",
          "properties": {
            "section_id": { "type": "number" },
            "section_name": { "type": "string" }
          },
          "required": ["section_id", "section_name"]
        },
        "minItems": 0
      }
    },
    "required": ["workplace_id", "workplace_name"]
  }
}

export type AryRisks = Array<{
  company_risk_id: number;
  risk_name: string;
  risk_description?: string|null;
  risk_source_type_id: number;
  risk_source_id: string;
  risk_priority_id: number;
  risk_qualification_id: string;
  risk_consequence_id: string;
  risk_probability_id: string;
}>;

export const schemaAryRisks: JSONSchemaType<AryRisks> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      company_risk_id: { type: "number" },
      risk_name: { type: "string" },
      risk_description: {
        type: "string",
        nullable: true
      },
      risk_source_type_id: { type: "number" },
      risk_source_id: { type: "string" },
      risk_priority_id: { type: "number" },
      risk_qualification_id: { type: "string" },
      risk_consequence_id: { type: "string" },
      risk_probability_id: { type: "string" }
    },
    required: [
      "company_risk_id",
      "risk_name",
      //"risk_description",
      "risk_source_type_id",
      "risk_source_id",
      "risk_priority_id",
      "risk_qualification_id",
      "risk_consequence_id",
      "risk_probability_id"
    ],
    additionalProperties: false
  }
};

export type AryMeasures = Array<{
  measure_id: number;
  measure_name: string;
  measure_description: string | null;
  type: string;
  status_id: number | null;
}>;

export const schemaAryMeasures: JSONSchemaType<AryMeasures> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      measure_id: { type: "number" },
      measure_name: { type: "string" },
      measure_description: { type: "string", nullable:true as false },
      type: { type: "string" },
      status_id: { type: "number", nullable: true as false }
    },
    required: ["measure_id", "measure_name", "measure_description", "type", "status_id"],
    additionalProperties: true
  }
};

export type AryAssessmentMeasures = Array<{
  company_risk_id: number;
  measures: AryMeasures;
}>;

export const schemaAryAssessmentMeasures: JSONSchemaType<AryAssessmentMeasures> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      company_risk_id: { type: "number" },
      measures: schemaAryMeasures
    },
    required: ["company_risk_id", "measures"],
    additionalProperties: true
  }
};

export type AryHistMeasures = Array<{
  budget: number | null;
  date: string;
  status_id: number;
}>;

export const schemaAryHistMeasures: JSONSchemaType<AryHistMeasures> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      budget:{ type: "number", nullable:true as false }, // <- quin bug no?
      date: { type: "string" },
      status_id: { type: "number" }
    },
    required: [ "budget", "date", "status_id"],
    additionalProperties: false
  }
};

export type AryMeasureDescription = Array<{
  measure_description: string;
}>;

export const schemaAryMeasureDescription: JSONSchemaType<AryMeasureDescription> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      measure_description: { type: "string" }
    },
    required: ["measure_description"],
    additionalProperties: false
  }
};

export type AryAssessment = Array<{
  assessment_description:string,
  assessment_id: number,
  end_date: string, // "2020-04-19 00:00:00"
  user_id_technician: string // "52307095N"
}>;
export const schemaAryAssessment: JSONSchemaType<AryAssessment> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      assessment_description: { type: "string" },
      assessment_id: { type: "number" },
      end_date: { type: "string", format: "iso-date-time" }, // "2020-04-19 00:00:00"
      user_id_technician: { type: "string" } // "52307095N"
    },
    required: ["assessment_description", "assessment_id", "end_date", "user_id_technician"]
  }
}

export type AssessmentDocument = {
  filename: string;
  b64file: string;
};

export const schemaAssessmentDocument: JSONSchemaType<AssessmentDocument> = {
  type: "object",
  properties: {
    filename: { type: "string" },
    b64file: { type: "string" }
  },
  required: ["filename", "b64file"],
  additionalProperties: false
};


export type AssessmentSource = {
  risk_source_type_id: number;
  risk_source_id: number;
  risk_name: string;
  checked?: boolean; // Per la UI
};
export type AryAssessmentSources = AssessmentSource[];

export const schemaAryAssessmentSources: JSONSchemaType<AryAssessmentSources> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      risk_source_type_id: { type: "number" },
      risk_source_id: { type: "number" },
      risk_name: { type: "string" },
      checked: { type: "boolean", nullable: true }
    },
    required: ["risk_source_type_id", "risk_source_id", "risk_name"],
    additionalProperties: false
  }
};

export type AryBills = Array<{
  bill_id: number;
  bill_serie: string | null;
  bill_number: number | null;
  import: number;
  concept: string;
  bill_date: string;
  provider: string;
  expiry_date: string;
}>;

export const schemaAryBills: JSONSchemaType<AryBills> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      bill_id: { type: "number" },
      bill_serie: { type: "string", nullable:true as false },
      bill_number: { type: "number", nullable:true as false },
      import: { type: "number" },
      concept: { type: "string" },
      bill_date: { type: "string" },
      provider: { type: "string" },
      expiry_date: { type: "string" }
    },
    required: [
      "bill_id",
      "bill_serie",
      "bill_number",
      "import",
      "concept",
      "bill_date",
      "provider",
      "expiry_date"
    ],
    additionalProperties: false
  }
};

export type BillDocument = {
  filename: string;
  b64file: string;
};

export const schemaBillDocument: JSONSchemaType<BillDocument> = {
  type: "object",
  properties: {
    filename: { type: "string" },
    b64file: { type: "string" }
  },
  required: ["filename", "b64file"],
  additionalProperties: false
};

export type AryLanguages = Array<{
  language_id: string;
  language_name: string;
}>;
export const schemaAryLanguages: JSONSchemaType<AryLanguages> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      language_id: { type: "string" },
      language_name: { type: "string" }
    },
    required: ["language_id", "language_name"],
    additionalProperties: false
  }
};

// Document upload requirements type and schema
export type DocumentUploadRequirements = {
  max_size_kb: number;
  valid_extensions: string[];
};
export const schemaDocumentUploadRequirements: JSONSchemaType<DocumentUploadRequirements> = {
  type: "object",
  properties: {
    max_size_kb: { type: "number" },
    valid_extensions: {
      type: "array",
      items: { type: "string" }
    }
  },
  required: ["max_size_kb", "valid_extensions"],
  additionalProperties: true
} as const;

// PRL Documents list type and schema
export type AryPrlDocuments = Array<{
  plr_documents_id: string;
  filename: string;
  extension: string;
  prl_document_path: string;
}>;
export const schemaAryPrlDocuments: JSONSchemaType<AryPrlDocuments> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      plr_documents_id: { type: "string" },
      filename: { type: "string" },
      extension: { type: "string" },
      prl_document_path: { type: "string" }
    },
    required: ["plr_documents_id", "filename", "extension", "prl_document_path"],
    additionalProperties: false
  }
} as const;

// PRL Document download response type and schema
export type PrlDocumentDownload = {
  filename: string;
  extension: string;
  b64file: string;
};
export const schemaPrlDocumentDownload: JSONSchemaType<PrlDocumentDownload> = {
  type: "object",
  properties: {
    filename: { type: "string" },
    extension: { type: "string" },
    b64file: { type: "string" }
  },
  required: ["filename", "extension", "b64file"],
  additionalProperties: false
} as const;

export type AryContractDocuments = Array<{
  company_contract_document_id: number;
  template_name: string;
  description: string;
  start_date: string;
}>;

export const schemaAryContractDocuments: JSONSchemaType<AryContractDocuments> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      company_contract_document_id: { type: "number" },
      template_name: { type: "string" },
      description: { type: "string" },
      start_date: { type: "string" }
    },
    required: [
      "company_contract_document_id",
      "template_name",
      "description",
      "start_date"
    ],
    additionalProperties: false
  }
};

export type AryCompanyDocuments = Array<{
  document_id: number;
  filename: string;
}>;

export const schemaAryCompanyDocuments: JSONSchemaType<AryCompanyDocuments> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      document_id: { type: "number" },
      filename: { type: "string" }
    },
    required: ["document_id", "filename"],
    additionalProperties: false
  }
};

export type AryCompanyWorkers = {
  contact_id: string, // "39422167Y",
  name: string|null, surname: string|null, second_surname: string|null,
  company_jobs: {
    company_worker_id: number,
    company_job_id: number,
    company_job_name: string
  }[]
}[];
export const schemaAryCompanyWorkers: JSONSchemaType<AryCompanyWorkers> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      contact_id: { type: "string" },
      name: { type: "string", nullable: true as false },
      surname: { type: "string", nullable: true as false },
      second_surname: { type: "string", nullable: true as false },
      company_jobs: {
        type: "array",
        items: {
          type: "object",
          properties: {
            company_worker_id: { type: "number" },
            company_job_id: { type: "number" },
            company_job_name: { type: "string" }
          },
          required: ["company_worker_id", "company_job_id", "company_job_name"]
        }
      }
    },
    required: ["contact_id", "name", "surname", "second_surname", "company_jobs"]
  }
};

export type AryCompanyJobs = {
  company_job_id: number,
  company_job_name: string
}[];
export const schemaAryCompanyJobs: JSONSchemaType<AryCompanyJobs> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      company_job_id: { type: "number" },
      company_job_name: { type: "string" }
    },
    required: ["company_job_id", "company_job_name"],
    additionalProperties: false
  }
};


export type course_status_t = "FORMAT"|"PENDENT"|"CONVOCAT"|"CADUCAT"|"CONVOCAT-CADUCAT"|"CURS-EXTERN"|"NO-APLICA";

export interface ICourse {
  courses_id: number,
  course_type_id: number,
  course_type_name: string,
  end_date: string | null, // "2019-11-15 00:00:00",
  duration: number,
  status_id: course_status_t
}
export interface IAgreement {
  agreement_id:number,
  course_type_name:string,
  status_id: course_status_t,
  end_date: string | null,
  COLOR: string,
  CURSOS: ICourse[]
}
export interface IPRLCourse {
  contact_id:string,
  agreements: IAgreement[]
}

export interface IArt19Meta {
  COLOR: string // "F63107",
  TRADUCCIO: {[lang:string]: string },
  ESTAT: course_status_t
}

export const schemaIPRLCourseStatus: JSONSchemaType<Record<course_status_t, IArt19Meta>> = {
  type: "object",
  propertyNames: {
    type: "string",
    enum: [
      "FORMAT",
      "PENDENT",
      "CONVOCAT",
      "CADUCAT",
      "CONVOCAT-CADUCAT",
      "CURS-EXTERN",
      "NO-APLICA"
    ]
  },
    additionalProperties: true,
    required: []
};

export const schemaAnyObj: JSONSchemaType<{ [some_id: string]: any }> = {
  type: "object",
  additionalProperties: true // auxiliar
};

export const schemaICourse: JSONSchemaType<ICourse> = {
  type: "object",
  properties: {
    courses_id: { type: "number" },
    course_type_id: { type: "number" },
    course_type_name: { type: "string" },
    end_date: {
      type: "string",
      nullable: true as false
    },
    duration: { type: "number" },
    status_id: {
      type: "string",
      enum: [
        "FORMAT",
        "PENDENT",
        "CONVOCAT",
        "CADUCAT",
        "CONVOCAT-CADUCAT",
        "CURS-EXTERN",
        "NO-APLICA"
      ]
    }
  },
  required: ["courses_id", "course_type_id", "course_type_name", "end_date", "duration", "status_id"],
  additionalProperties: false
};

export const schemaIcourses: JSONSchemaType<ICourse[]> = {
  type: "array",
  items: schemaICourse
}

export const schemaAgreement: JSONSchemaType<IAgreement> = {
  type: "object",
  properties:{
    agreement_id: {type: "number"},
    course_type_name: {type: "string" },
    status_id: {
      type: "string",
      enum: [
        "FORMAT",
        "PENDENT",
        "CONVOCAT",
        "CADUCAT",
        "CONVOCAT-CADUCAT",
        "CURS-EXTERN",
        "NO-APLICA"
      ]
    },
    end_date: {
      type: "string",
      nullable: true as false
    },
    COLOR: {type: "string"},
    CURSOS: schemaIcourses
  },
  required: ["agreement_id","course_type_name","status_id","COLOR", "CURSOS"],
  additionalProperties: false
};

export const schemaAgreements: JSONSchemaType<IAgreement[]> = {
  type:"array",
  items: schemaAgreement
}


export const schemaIPRLCourse: JSONSchemaType<IPRLCourse> = {
  type: "object",
  properties: {
    contact_id: { type: "string" },
    agreements: schemaAgreements
  },
  required: ["contact_id", "agreements"],
  additionalProperties: false
};

export const schemaIPRLCourses: JSONSchemaType<IPRLCourse[]> = {
  type: "array",
  items: schemaIPRLCourse
};



export type AryCompanyCourses = {
  [nid: string]: {
    contact_id: string,
    course_type_name: string,
    courses_art19: {
      courses_id: number,
      duration: number,
      status_id: number
    }[],
    status_art19: {
      COLOR: string,
      TRADUCCIO: { [lang: string]: string },
      ESTAT: string,
      DATA: string
    }[]
  }
};
const traduccioSchema: JSONSchemaType<{ [lang: string]: string }> = {
  type: "object",
  propertyNames: { type: "string" },
  additionalProperties: { type: "string" },
  required: []
};

const statusArt19Schema: JSONSchemaType<{
  COLOR: string;
  TRADUCCIO: { [lang: string]: string };
  ESTAT: string;
  DATA: string;
}[]> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      COLOR: { type: "string" },
      TRADUCCIO: traduccioSchema,
      ESTAT: { type: "string" },
      DATA: { type: "string" }
    },
    required: ["COLOR", "TRADUCCIO", "ESTAT", "DATA"],
    additionalProperties: false
  }
};

export const schemaAryCompanyCourses: JSONSchemaType<AryCompanyCourses> = {
  type: "object",
  required: [],
  additionalProperties: {
    type: "object",
    properties: {
      contact_id: { type: "string" },
      course_type_name: { type: "string" },
      courses_art19: {
        type: "array",
        items: {
          type: "object",
          properties: {
            courses_id: { type: "number" },
            duration: { type: "number" },
            status_id: { type: "number" }
          },
          required: ["courses_id", "duration", "status_id"],
          additionalProperties: false
        }
      },
      status_art19: statusArt19Schema
    },
    required: ["contact_id", "course_type_name", "courses_art19", "status_art19"],
    additionalProperties: false
  }
};

export type AryWorkerCourses = {
  [k: string]: {
    contact_id: string,
    course_type_name: string,
    courses_art19: {
      courses_id: number,
      duration: number,
      status_id: number
    }[],
    status_art19: {
      COLOR: string,
      TRADUCCIO: { [lng: string]: string },
      ESTAT: string,
      DATA: string
    }[]
  }
};


export const schemaAryWorkerCourses: JSONSchemaType<AryWorkerCourses> = {
  type: "object",
  required: [],
  additionalProperties: {
    type: "object",
    properties: {
      contact_id: { type: "string" },
      course_type_name: { type: "string" },
      courses_art19: {
        type: "array",
        items: {
          type: "object",
          properties: {
            courses_id: { type: "number" },
            duration: { type: "number" },
            status_id: { type: "number" }
          },
          required: ["courses_id", "duration", "status_id"],
          additionalProperties: false
        }
      },
      status_art19: {
        type: "array",
        items: {
          type: "object",
          properties: {
            COLOR: { type: "string" },
            TRADUCCIO: traduccioSchema,
            ESTAT: { type: "string" },
            DATA: { type: "string" }
          },
          required: ["COLOR", "TRADUCCIO", "ESTAT", "DATA"],
          additionalProperties: false
        }
      }
    },
    required: ["contact_id", "course_type_name", "courses_art19", "status_art19"],
    additionalProperties: false
  }
};

export type AryWorkerMachines = Array<{
  company_machine_id: number,
  machine_id: number|null,
  name: string,
  function: string,
  status_id: number,
  document_id_image: number|null,
}>;

export const schemaAryWorkerMachines: JSONSchemaType<AryWorkerMachines> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      company_machine_id: { type: "number" },
      machine_id: { type: "number", nullable:true as false },
      name: { type: "string" },
      function: { type: "string" },
      status_id: { type: "number" },
      document_id_image: { type: "number", nullable:true as false },
    },
    required: [
      "company_machine_id",
      "machine_id",
      "name",
      "function",
      "status_id",
      "document_id_image"
    ],
    additionalProperties: false
  }
};

export type AryWorkerChemicals = Array<{
  company_chemical_id: number,
  chemical_id: number | null,
  name: string,
  description: string,
  status_id: number
}>;

export const schemaAryWorkerChemicals: JSONSchemaType<AryWorkerChemicals> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      company_chemical_id: { type: "number" },
      chemical_id: { type: "number", nullable:true as false },
      name: { type: "string" },
      description: { type: "string", nullable:true as false },
      status_id: { type: "number" }
    },
    required: [
      "company_chemical_id",
      "chemical_id",
      "name",
      "description",
      "status_id"
    ],
    additionalProperties: false
  }
};

export type AryCheckups = Array<{
  checkup_id: number,
  contact_id: string,
  mark_medical_certificate: string | null,
  mark_time_agenda: string | null,
  status_id: number,
  aptitude_id: number | null,
  aptitude_temporality: number,
  company_job_ids: number[]
}>;

export const schemaAryCheckups: JSONSchemaType<AryCheckups> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      checkup_id: { type: "number" },
      contact_id: { type: "string" },
      mark_medical_certificate: { type: "string", nullable: true as false },
      mark_time_agenda: { type: "string", nullable: true as false },
      status_id: { type: "number" },
      aptitude_id: { type: "number", nullable: true as false },
      aptitude_temporality: { type: "number" },
      company_job_ids: {
        type: "array",
        items: { type: "number" }
      }
    },
    required: [
      "checkup_id",
      "contact_id",
      "mark_medical_certificate",
      "mark_time_agenda",
      "status_id",
      "aptitude_id",
      "aptitude_temporality",
      "company_job_ids"
    ],
    additionalProperties: false
  }
};

export type AryCheckupQuestions = Array<{
  checkup_question_id: number,
  //checkup_question_id_father?:number,
  checkup_question_value: string,
  question_name: string,
  question_input_format_id: string,
  area_questionnair_id: number,
  area_questionnair_name: string,
  area_questionnair_block_id: number,
  area_questionnair_block_name: string,
  order: number,
  values: Array<{
    value_name: string,
    value: string
  }>
}>;

export const schemaAryCheckupQuestions: JSONSchemaType<AryCheckupQuestions> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      checkup_question_id: { type: "number" },
      checkup_question_value: { type: "string" },
      question_name: { type: "string" },
      question_input_format_id: { type: "string" },
      area_questionnair_id: { type: "number" },
      area_questionnair_name: { type: "string" },
      area_questionnair_block_id: { type: "number" },
      area_questionnair_block_name: { type: "string" },
      order: { type: "number" },
      values: {
        type: "array",
        items: {
          type: "object",
          properties: {
            value_name: { type: "string" },
            value: { type: "string" }
          },
          required: ["value_name", "value"],
          additionalProperties: false
        }
      }
    },
    required: [
      "checkup_question_id",
      "checkup_question_value",
      "question_name",
      "question_input_format_id",
      "area_questionnair_id",
      "area_questionnair_name",
      "area_questionnair_block_id",
      "area_questionnair_block_name",
      "order",
      "values"
    ],
    additionalProperties: false
  }
};

export type AryCoursesStatus = Array<{
  status_id: number,
  status_name: string
}>;

export const schemaAryCoursesStatus: JSONSchemaType<AryCoursesStatus> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      status_id: { type: "number" },
      status_name: { type: "string" }
    },
    required: ["status_id", "status_name"],
    additionalProperties: false
  }
};

export type FileBlobResponse = {
  filename: string;
  b64file: string;
};

export const schemaFileBlobResponse: JSONSchemaType<FileBlobResponse> = {
  type: "object",
  properties: {
    filename: { type: "string" },
    b64file: { type: "string" }
  },
  required: ["filename", "b64file"],
  additionalProperties: false
};

export type AryCheckupStatus = Array<{
  status_id: number | string,
  status_name: string
}>;

export const schemaAryCheckupStatus: JSONSchemaType<AryCheckupStatus> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      status_id: { type: ["number", "string"] },
      status_name: { type: "string" }
    },
    required: ["status_id", "status_name"],
    additionalProperties: false
  }
};

export type AryAvailableAptitudeTypes = Array<{
  aptitude_id: number,
  aptitude_name: string
}>;

export const schemaAryAvailableAptitudeTypes: JSONSchemaType<AryAvailableAptitudeTypes> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      aptitude_id: { type: "number" },
      aptitude_name: { type: "string" }
    },
    required: ["aptitude_id", "aptitude_name"],
    additionalProperties: false
  }
};

export type AryMachinesStatus = Array<{
  status_id: number,
  status_name: string
}>;

export const schemaAryMachinesStatus: JSONSchemaType<AryMachinesStatus> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      status_id: { type: "number" },
      status_name: { type: "string" }
    },
    required: ["status_id", "status_name"],
    additionalProperties: false
  }
};

export type ImageBlob = {
  document_id_image: number;
  b64file: string;
  extension: string;
};

export const schemaImageBlob: JSONSchemaType<ImageBlob> = {
  type: "object",
  properties: {
    document_id_image: { type: "number" },
    b64file: { type: "string" },
    extension: { type: "string" }
  },
  required: ["document_id_image", "b64file", "extension"],
  additionalProperties: false
};

export type AryIpeWorkers = Array<{
  company_worker_id: number,
  risk_source_type_id: number,
  risk_source_id: number,
  company_proteccions_id: number,
  company_protections_name: string,
  sent: string | null,
  validated: string | boolean | null
}>;

// extensió dels elements retornats a AryIpeWorkers,
// en faig un tipus diferent, per no causar el caos amb el codi previ
export interface IUserIpe {
  company_worker_id: number,
  risk_source_type_id: number,
  risk_source_id: number,
  company_proteccions_id: number,
  company_protections_name: string,
  sent: string | null,
  validated: string | boolean | null
  company_proteccions_workers_deliveries_document_id:number,
  company_proteccions_workers_deliveries_id:number,
  company_proteccions_workers_id: number,
  useful_life: string | null
};

export const schemaAryIpeWorkers: JSONSchemaType<AryIpeWorkers> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      company_worker_id: { type: "number" },
      risk_source_type_id: { type: "number" },
      risk_source_id: { type: "number" },
      company_proteccions_id: { type: "number" },
      company_protections_name: { type: "string"}, 
      sent: { type: "string", nullable: true as false },
      validated: { type: ["string", "boolean"], nullable: true as false }
    },
    required: [
      "company_worker_id",
      "risk_source_type_id",
      "risk_source_id",
      "company_proteccions_id",
      "sent",
      "validated"
    ],
    additionalProperties: false
  }
};

export type IPEDelivery = 'ENTREGATS'|'NO-ENTREGATS'|'SIGNATS';

export type IpeInfo = {
  company_proteccions_id: number,
  company_protections_company_id: string,
  risk_source_type_id: number,
  risk_source_id: string | number,
  protections_id: number,
  company_protections_name: string,
  company_protections_description: string,
  company_protections_documents_id: number | string | null,
  company_proteccions_required: number,
  body_parts_id: number,
  company_proteccions_normative: string | null
};

export const schemaIpeInfo: JSONSchemaType<IpeInfo> = {
  type: "object",
  properties: {
    company_proteccions_id: { type: "number" },
    company_protections_company_id: { type: "string" },
    risk_source_type_id: { type: "number" },
    risk_source_id: { type: ["string", "number"] },
    protections_id: { type: "number" },
    company_protections_name: { type: "string" },
    company_protections_description: { type: "string" },
    company_protections_documents_id: { type: ["number", "string"], nullable: true as false },
    company_proteccions_required: { type: "number" },
    body_parts_id: { type: "number" },
    company_proteccions_normative: { type: "string", nullable: true as false }
  },
  required: [
    "company_proteccions_id",
    "company_protections_company_id",
    "risk_source_type_id",
    "risk_source_id",
    "protections_id",
    "company_protections_name",
    "company_protections_description",
    "company_protections_documents_id",
    "company_proteccions_required",
    "body_parts_id",
    "company_proteccions_normative"
  ],
  additionalProperties: false
};

export type AryIpeTypes = Array<{
  company_protections_type: string,
  company_protections_type_translation: string
}>;

export const schemaAryIpeTypes: JSONSchemaType<AryIpeTypes> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      company_protections_type: { type: "string" },
      company_protections_type_translation: { type: "string" }
    },
    required: ["company_protections_type", "company_protections_type_translation"],
    additionalProperties: false
  }
};

export type AryBodyParts = Array<{
  body_parts_id: number,
  body_parts_name: string
}>;

export const schemaAryBodyParts: JSONSchemaType<AryBodyParts> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      body_parts_id: { type: "number" },
      body_parts_name: { type: "string" }
    },
    required: ["body_parts_id", "body_parts_name"],
    additionalProperties: false
  }
};

export type AryIdentifierTypes = Array<{
  identifier_type_id: string,
  identifier_type_name: string
}>;

export const schemaAryIdentifierTypes: JSONSchemaType<AryIdentifierTypes> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      identifier_type_id: { type: "string" },
      identifier_type_name: { type: "string" }
    },
    required: ["identifier_type_id", "identifier_type_name"],
    additionalProperties: false
  }
};

export type ArySexIds = Array<{
  sex_id: string,
  sex_name: string
}>;

export const schemaArySexIds: JSONSchemaType<ArySexIds> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      sex_id: { type: "string" },
      sex_name: { type: "string" }
    },
    required: ["sex_id", "sex_name"],
    additionalProperties: false
  }
};

export type AryUpcomingCheckups = Array<{
  checkup_id: number,
  checkup_workplace_id: number,
  mark_time_agenda: string,
  workplace_zip_code_id: number,
  workplace_town_id: number,
  workplace_region_id: number,
  workplace_province_id: number,
  workplace_autonomous_community_id: number,
  workplace_country_id: number,
  signature: boolean,
  questionary_answered: 0|1|2,
}>;

export const schemaAryUpcomingCheckups: JSONSchemaType<AryUpcomingCheckups> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      checkup_id: { type: "number" },
      checkup_workplace_id: { type: "number" },
      mark_time_agenda: { type: "string" },
      workplace_zip_code_id: { type: "number" },
      workplace_town_id: { type: "number" },
      workplace_region_id: { type: "number" },
      workplace_province_id: { type: "number" },
      workplace_autonomous_community_id: { type: "number" },
      workplace_country_id: { type: "number" },
      signature: { type: "boolean" },
      questionary_answered: { type: "number" }
    },
    required: [
      "checkup_id",
      "checkup_workplace_id",
      "mark_time_agenda",
      "workplace_zip_code_id",
      "workplace_town_id",
      "workplace_region_id",
      "workplace_province_id",
      "workplace_autonomous_community_id",
      "workplace_country_id"
    ],
    additionalProperties: false
  }
};

export type AryMedicalCenters = {
  company_name: string,
  medical_centers: Array<{
    town_id:number,
    mobil_unit: boolean,
    external: boolean,
    workplace_id: number,
    workplace_name: string,
    workplace_adress: string,
    workplace_schedule: string | null
  }>
};

export const schemaAryMedicalCenters: JSONSchemaType<AryMedicalCenters> = {
  type: "object",
  properties: {
    company_name: { type: "string" },
    medical_centers: {
      type: "array",
      items: {
        type: "object",
        properties: {
          town_id: { type: "number" },
          mobil_unit: { type: "boolean" },
          external: { type: "boolean" },
          workplace_id: { type: "number" },
          workplace_name: { type: "string" },
          workplace_adress: { type: "string" },
          workplace_schedule: { type: "string", nullable:true as false }
        },
        required: [
          "workplace_id",
          "workplace_name",
          "workplace_adress",
          "workplace_schedule"
        ],
        additionalProperties: false
      }
    }
  },
  required: ["company_name", "medical_centers"],
  additionalProperties: false
};

export type AryWorkerContactMethods = Array<{
  contact_method_id: number,
  contact_method_name: string,
  contact_method_type: string, // "E", "P", "M", "C"
  contact_method_data: string | {
    country: string,
    autonomous_community: string,
    province: string,
    region: string,
    town: string,
    zip_code: string,
    street: string
  },
  personal: string
}>;

export const schemaAryWorkerContactMethods: JSONSchemaType<AryWorkerContactMethods> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      contact_method_id: { type: "number" },
      contact_method_name: { type: "string" },
      contact_method_type: { type: "string" },
      contact_method_data: {
        oneOf: [
          { type: "string" },
          {
            type: "object",
            properties: {
              country: { type: "string" },
              autonomous_community: { type: "string" },
              province: { type: "string" },
              region: { type: "string" },
              town: { type: "string" },
              zip_code: { type: "string" },
              street: { type: "string" }
            },
            required: [
              "country",
              "autonomous_community",
              "province",
              "region",
              "town",
              "zip_code",
              "street"
            ],
            additionalProperties: false
          }
        ]
      },
      personal: { type: "string" }
    },
    required: [
      "contact_method_id",
      "contact_method_name",
      "contact_method_type",
      "contact_method_data",
      "personal"
    ],
    additionalProperties: false
  }
};
export type AryZipCodeData = Array<{
  zip_code_id: number,
  zip_code: string,
  town_id: number,
  town_name: string,
  region_id: number,
  region_name: string,
  province_id: number,
  province_name: string,
  autonomous_community_id: number,
  autonomous_community_name: string,
  country_id: number,
  country_name: string,
  IBAN_code: string
}>;

export const schemaAryZipCodeData: JSONSchemaType<AryZipCodeData> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      zip_code_id: { type: "number" },
      zip_code: { type: "string" },
      town_id: { type: "number" },
      town_name: { type: "string" },
      region_id: { type: "number" },
      region_name: { type: "string" },
      province_id: { type: "number" },
      province_name: { type: "string" },
      autonomous_community_id: { type: "number" },
      autonomous_community_name: { type: "string" },
      country_id: { type: "number" },
      country_name: { type: "string" },
      IBAN_code: { type: "string" }
    },
    required: [
      "zip_code_id",
      "zip_code",
      "town_id",
      "town_name",
      "region_id",
      "region_name",
      "province_id",
      "province_name",
      "autonomous_community_id",
      "autonomous_community_name",
      "country_id",
      "country_name",
      "IBAN_code"
    ],
    additionalProperties: false
  }
};

export type ArySalutCheckup = {
  [clau: string]: {
    question_name: string,
    checkup_question_value: string,
    value_name: string,
    value_id: number,
    result?: boolean,
    alter_result?: boolean,
    side?: number,
    type?: string
  }
};

export const schemaArySalutCheckup: JSONSchemaType<ArySalutCheckup> = {
  type: "object",
  required: [],
  additionalProperties: {
    type: "object",
    properties: {
      question_name: { type: "string" },
      checkup_question_value: { type: "string", nullable: true as false },
      value_name: { type: "string", nullable: true as false },
      value_id: { type: "number", nullable: true as false },
      result: { type: "boolean", nullable: true },
      alter_result: { type: "boolean", nullable: true },
      side: { type: "number", nullable: true },
      type: { type: "string", nullable: true }
    },
    required: [
      "question_name",
      "checkup_question_value",
      "value_name",
      "value_id"
    ],
    additionalProperties: false
  }
};

export type AryRiscSourceName = { risk_source_name: string }[];
export const schemaAryRiscSourceName:  JSONSchemaType<AryRiscSourceName> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      risk_source_name: { type: "string" }
    },
    required: [ "risk_source_name" ]
  }
}

export type AryVisitReports = Array<{
  visit_report_id: number,
  visit_report_type_id: number,
  visit_report_type_version: number,
  visit_report_type_title: string,
  mark_time: string, // "2021-05-25 14:17:30"
}>

export const schemaAryVisitReports: JSONSchemaType<AryVisitReports> = {
  type: "array",
  items: {
    type: "object",
    properties: {
      visit_report_id: { type: "number" },
      visit_report_type_id: { type: "number" },
      visit_report_type_version: { type: "number" },
      visit_report_type_title: {type: "string" },
      mark_time: { type: "string", format: "iso-date-time" }
    },
    required: ["visit_report_id", "visit_report_type_id", "visit_report_type_title", "visit_report_type_version", "mark_time"],
  }
}



